import { useNavigate } from "@tanstack/react-router";
import { memo, useCallback } from "react";
import Close from "~icons/material-symbols/close";
import { css } from "../../../../styled-system/css";
import bousaiMiyapo from "../../../assets/miyagi/bousai-miyapo.png";
import {
  MIYAGI_BOUSAI_SERVICE_ID,
  MIYAGI_RESIDENCE_CARD_CAMPAIGN_NAME,
} from "../../../config";
import { t } from "../../../libs/i18n";
import { encodeUUID } from "../../../libs/ps";
import { isMockEnv } from "../../../libs/utils";

type MiyagiResidenceCardModalProps = {
  onClickCancel: () => void;
};

export const MiyagiResidenceCardModal = memo(
  ({ onClickCancel }: MiyagiResidenceCardModalProps) => {
    const navigate = useNavigate();

    const handleOutsideClick = (
      e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    ) => {
      if (e.target === e.currentTarget) {
        onClickCancel();
      }
    };

    const handleClickApplyWithBousai = useCallback(() => {
      // 経路を保存
      localStorage.setItem("bousai_callback_source", "miyagi-residence-card");

      if (isMockEnv()) {
        navigate({ to: "/lottery/bousai/mock" });
      } else {
        location.href = `https://p8n.jp/i/${encodeUUID(MIYAGI_BOUSAI_SERVICE_ID)}?u=${encodeURIComponent("#/campaign/miyagi-point")}`;
      }

      onClickCancel();
    }, [onClickCancel, navigate]);

    return (
      <div
        className={css({
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          bg: "rgba(0, 0, 0, 0.1)",
          zIndex: 888,
        })}
      >
        {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
        <div
          className={css({
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 999,
            backdropFilter: "blur(3px)",
            transition: "transform 0.3s ease-out",
            transform: "translateY(100%)",
            animation: "slide-up 0.3s forwards",
          })}
          onClick={handleOutsideClick}
        >
          <div
            className={css({
              bg: "white",
              roundedTop: "2xl",
              px: "16px",
              pt: "16px",
              pb: "48px",
              display: "flex",
              flexDir: "column",
              gap: "16px",
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              zIndex: 999,
            })}
          >
            <div>
              <div
                className={css({
                  display: "flex",
                })}
              >
                <div
                  className={css({
                    color: "text.primary",
                    fontSize: "18px",
                    fontWeight: 500,
                  })}
                >
                  {t("{name}を受け取りましょう！", {
                    name: MIYAGI_RESIDENCE_CARD_CAMPAIGN_NAME,
                  })}
                </div>

                <button
                  type="button"
                  className={css({
                    color: "text.primary",
                    border: "none",
                    cursor: "pointer",
                    ml: "auto",
                    bg: "action.hover",
                    rounded: "full",
                    p: "4px",
                  })}
                  onClick={onClickCancel}
                >
                  <Close />
                </button>
              </div>
              <p
                className={css({
                  color: "text.secondary",
                  fontSize: "14px",
                })}
              >
                {t("まずは「みやぎ防災ミニアプリ」に登録")}
              </p>
            </div>
            <p>
              {t(
                "ポイントの受け取りにはみやぎ防災ミニアプリの登録が必要です。登録完了後、特定在留カード等の読み取りを行うと、その場でポイントが付与されます。",
              )}
            </p>
            <div
              className={css({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              })}
            >
              <img
                src={bousaiMiyapo}
                alt={t("防災アプリに登録")}
                className={css({
                  w: "176px",
                })}
              />
            </div>
            <div
              className={css({
                display: "flex",
                gap: "10px",
                flexDir: "column",
              })}
            >
              <button
                type="button"
                className={css({
                  bg: "surface.accentPrimary",
                  color: "white",
                  rounded: "2xl",
                  p: "12px",
                })}
                onClick={handleClickApplyWithBousai}
              >
                {t("防災に登録して受け取りへ")}
              </button>
              <button
                type="button"
                className={css({
                  bg: "rgba(229, 231, 235, 0.50)",
                  rounded: "2xl",
                  p: "12px",
                })}
                onClick={onClickCancel}
              >
                {t("あとで")}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  },
);
